import { ReactNode, useEffect, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { baseApi } from "../../redux/api";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { LANDING_PAGE_URL } from "../../utils/constants";
import { isAdminAuthCookieSet } from "../../utils/helpers";
import { ScrollToTop } from "../scrollToTop";

export const AdminAuthLayout = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();

  const location = useLocation();

  const container = useRef<HTMLDivElement>(null);

  const { isAdminSignedIn } = useAppSelector((state) => state.auth);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const isAuthSet = isAdminAuthCookieSet();
    if (isAuthSet && isAdminSignedIn) {
      if (location.pathname === "/backup-codes") return;
      navigate("/overview");
    } else {
      dispatch(baseApi.util.resetApiState());
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <>
      <ScrollToTop
        changeKey={location.pathname}
        rerunOnKeyChange
        scrollIntoView
      />

      <div className="flex h-screen max-h-[100dvh] flex-col bg-grey-50">
        <div className="border-b border-grey-100 py-6 md:py-6">
          <div className="max-width">
            <NavLink to={LANDING_PAGE_URL} className={"block w-fit"}>
              <img src="/assets/logo_admin.svg" className="bg-red" alt="logo" />
            </NavLink>
          </div>
        </div>

        <div id="pageTopRefToScroll" className="h-0" />
        <div
          ref={container}
          className="max-width flex flex-1 justify-center overflow-y-scroll py-9 md:py-16"
        >
          <div className="h-fit w-full max-w-[440px] rounded-2xl bg-white px-5 py-16 md:p-8">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};
